var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleRewardsClubBanner)?_c('div',{staticClass:"lineBanner"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.words.label))]),_c('div',{staticClass:"btnArea"},[_c('router-link',{staticClass:"btn",attrs:{"to":"/pages/2024mghrec"}},[_c('div',{staticClass:"copy"},[_c('div',[_vm._v("MGH Rewards Club法人会員連携")])])])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }